import React from "react";
import '../../assets/css/buttons/NormalSizeSignUpBtn.css';


const NormalSizeSignUpBtn = ({onClickDo, children}) => {
    return (
        <button onClick={onClickDo ? onClickDo : undefined} type="button" className="flex flexCenter NormalSizeSignUpBtn">
            {children ? children : "SIGN UP"}
        </button>
    );
}

export default NormalSizeSignUpBtn;